import { type MutationHookOptions, useMutation } from "@apollo/client";
import {
  CreateChatBanMutation,
  DeleteChatBanMutation,
  DeleteChatMessageMutation,
} from "../graphql/mutations";
import type {
  CreateChatBanMutationType,
  CreateChatBanMutationVariablesType,
  DeleteChatBanMutationType,
  DeleteChatBanMutationVariablesType,
  DeleteChatMessageMutationType,
  DeleteChatMessageMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useDeleteChatMessageMutation = (
  options?: MutationHookOptions<
    DeleteChatMessageMutationType,
    DeleteChatMessageMutationVariablesType
  >
) => {
  return useMutation<
    DeleteChatMessageMutationType,
    DeleteChatMessageMutationVariablesType
  >(DeleteChatMessageMutation, options);
};

export const useCreateChatBanMutation = (
  options?: MutationHookOptions<
    CreateChatBanMutationType,
    CreateChatBanMutationVariablesType
  >
) => {
  return useMutation<
    CreateChatBanMutationType,
    CreateChatBanMutationVariablesType
  >(CreateChatBanMutation, options);
};

export const useDeleteChatBanMutation = (
  options?: MutationHookOptions<
    DeleteChatBanMutationType,
    DeleteChatBanMutationVariablesType
  >
) => {
  return useMutation<
    DeleteChatBanMutationType,
    DeleteChatBanMutationVariablesType
  >(DeleteChatBanMutation, options);
};
